import { Col, Form, Row, Input, Button, Spin, DatePicker, InputNumber } from 'antd';
import React, { useEffect, useState } from 'react';
import { ORDER_TYPE } from '../../../constants';
import { ReactSVG } from 'react-svg';
import './Pricing.scss';
import PricingRange from './PricingRange';

const initValuesForm = {};

const initPricingData = {
  minOrders: 1,
  maxOrders: null,
  price: 6.5,
};

const orderTypes = Object.keys(ORDER_TYPE);
const initPricingRanges = {};
const initPricingRangeData = {};
const initValid = {};
orderTypes?.forEach((orderType) => {
  initPricingRanges[orderType] = true;
  initValid[orderType] = true;
  initPricingRangeData[orderType] = [initPricingData];
});

const PricingForm = ({
  handleCancel,
  handleOk,
  handleDelete,
  pricing,
  // companies = [],
  isModalOpen,
  isFetching,
  // typePage = TYPE_PAGE.DRAFT,
}) => {
  const [formPricing] = Form.useForm();
  const [pricingRange, setPricingRange] = useState(initPricingRanges);
  const [pricingRangeData, setPricingRangeData] = useState(initPricingRangeData);
  const [isValid, setIsValid] = useState(initValid);

  useEffect(() => {
    if (pricing) {
      formPricing.setFieldsValue({
        ...pricing,
      });
      const newPricingRange = {};
      const newPricingRangeData = {};
      orderTypes?.forEach((orderType) => {
        const pricingData = pricing.pricingRanges[orderType];
        newPricingRange[orderType] = pricingData?.length > 0;
        newPricingRangeData[orderType] = pricingData;
      });
      setPricingRangeData(newPricingRangeData);
      setPricingRange(newPricingRange);
    } else {
      formPricing.resetFields();
      setPricingRange(initPricingRanges);
      setPricingRangeData(initPricingRangeData);
    }
  }, [formPricing, pricing, isModalOpen]);

  const onCancel = () => {
    handleCancel && handleCancel();
  };

  const onOk = () => {
    formPricing.submit();
  };

  const onAddRange = (orderType) => {
    const existingRangeData = pricingRangeData[orderType];
    const lastRange = existingRangeData[existingRangeData.length - 1];
    const newMinValue = lastRange ? lastRange.maxOrders + 1 : 1;

    const newPricingRangeData = {
      ...pricingRangeData,
      [orderType]: [
        ...pricingRangeData[orderType],
        {
          minOrders: newMinValue,
          maxOrders: null,
          price: null,
        },
      ],
    };
    setPricingRangeData(newPricingRangeData);
  };

  const onDeleteRange = async (orderType) => {
    const updatedPricingRangeData = { ...pricingRangeData };
    const updatedRangeList = [...updatedPricingRangeData[orderType]];

    if (updatedRangeList.length > 0) {
      const deletedRange = updatedRangeList.slice(-1)[0];
      if (deletedRange.id) {
        await handleDelete(deletedRange, pricing.id);
      }
      updatedRangeList.pop(); // Remove the last range
      updatedPricingRangeData[orderType] = updatedRangeList;
      setPricingRangeData(updatedPricingRangeData);
    }
  };

  const updateRangeValue = (index, orderType, updatedValue) => {
    const updatedPricingRangeData = { ...pricingRangeData };

    // Update the pricing range
    updatedPricingRangeData[orderType] = updatedPricingRangeData[orderType].map((range, i) =>
      i === index ? { ...range, ...updatedValue } : range,
    );

    const ranges = updatedPricingRangeData[orderType];

    // Check validity of pricing
    const hasNegativePrice = ranges.some((range) => range.price < 0 || range.price == null);

    // Check validity of ranges
    const hasInvalidRanges = ranges.some((range, i) => {
      const isFirstRange = i === 0;
      const isLastRange = i === ranges.length - 1;
      const isMinOrdersInvalid = isFirstRange ? range.minOrders !== 1 : range.minOrders > (range.maxOrders || Infinity);

      let isMaxOrdersInvalid = false;
      if (!isLastRange) {
        // For non-last ranges, maxOrders should be defined and greater than minOrders
        isMaxOrdersInvalid = range.maxOrders == null || range.minOrders > range.maxOrders;
      } else {
        // For the last range, maxOrders should be null
        isMaxOrdersInvalid = range.maxOrders !== null;
      }
      return isMinOrdersInvalid || isMaxOrdersInvalid;
    });

    // Check for overlapping ranges
    const hasOverlappingRanges = ranges.some((range, i) => {
      if (i === 0) return false; // Skip the first range
      const prevRange = ranges[i - 1];

      // Check for overlapping ranges (minOrders <= maxOrders of the previous range)
      if (range.minOrders <= prevRange.maxOrders) return true;

      // Check for gaps between ranges
      if (range.minOrders > prevRange.maxOrders + 1) return true;

      return false;
    });

    // Set Validity of order type pricing range
    const newValidity = { ...isValid };
    newValidity[orderType] = !hasNegativePrice && !hasInvalidRanges && !hasOverlappingRanges;
    setIsValid(newValidity);

    setPricingRangeData(updatedPricingRangeData);
  };

  const onFinishForm = (values) => {
    const params = { ...values };
    params.pricingRanges = pricingRangeData;
    handleOk && handleOk(params);
  };

  const onClickOrderType = () => {
    // Commented out because defining a pricing for all types is now mandatory
    // const preValue = pricingRange[orderType];
    // const newPricingRange = { ...pricingRange };
    // newPricingRange[orderType] = !pricingRange[orderType];
    // // fix correct deselecting of ordertype
    // let newPricingRangeData = { ...pricingRangeData };
    // // Initialize new order type data if it's not already present
    // if (!newPricingRangeData[orderType]) {
    //   newPricingRangeData[orderType] = [{ ...initPricingData }];
    // }
    // // Fix correct deselecting of ordertype
    // if (preValue) {
    //   // Set to initial state when deselecting
    //   newPricingRangeData[orderType] = [initPricingData];
    // }
    // setPricingRangeData(newPricingRangeData);
    // setPricingRange(newPricingRange);
  };

  return (
    <Spin spinning={isFetching}>
      <div className="PricingForm">
        <Form
          form={formPricing}
          scrollToFirstError
          layout="vertical"
          requiredMark={false}
          colon={false}
          className="FormContent"
          onFinish={onFinishForm}
          initialValues={initValuesForm}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Required' }]}>
                <Input size="large" placeholder="Pricing profile name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Start date" name="startDate" rules={[{ required: true, message: 'Required' }]}>
                <DatePicker size="large" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="End date" name="endDate" rules={[{ required: false }]}>
                <DatePicker size="large" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Daily minimum" name="dailyMinimum">
                <InputNumber size="large" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Weekly minimum" name="weeklyMinimum">
                <InputNumber size="large" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <div className="pricingRanges">
                <label>Pricing Ranges</label>
                <div className="types-content">
                  {orderTypes.map((orderType) => (
                    <Button
                      key={orderType}
                      className={`content ${pricingRange[orderType] ? 'selected' : ''}`}
                      onClick={() => onClickOrderType([orderType])}
                    >
                      {orderType}
                    </Button>
                  ))}
                </div>
              </div>
            </Col>
            {orderTypes
              .filter((orderType) => pricingRange[orderType])
              .map((orderType) => (
                <Col span={24} key={orderType + 'data'}>
                  <PricingRange
                    orderType={orderType}
                    onAddRange={onAddRange}
                    onDeleteRange={onDeleteRange}
                    updateRangeValue={updateRangeValue}
                    pricingRanges={pricingRangeData[orderType]}
                    isValid={isValid}
                  />
                </Col>
              ))}
          </Row>
        </Form>
      </div>
      <div className="FormFooter">
        <Button className="ButtonCancel" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          className="CreateButton ButtonPrimary"
          type="primary"
          onClick={onOk}
          disabled={Object.values(isValid).some((value) => value === false)}
        >
          {pricing ? 'Edit' : 'Create'}
          <ReactSVG className="icon" src="/icons/done.svg" />
        </Button>
      </div>
    </Spin>
  );
};

export default PricingForm;
